import moment from "moment/moment";
import React from "react";
import { useNavigate, useOutletContext } from "react-router";
import { NoticeListContainer } from "../../notice/component/styled";
import { ListContainer } from "../../productList/component/styled";
import Portfolio from "../../portfolio/portfolioPage/portfolio";
import Product from "../../productList/component/productList/product";

const SearchSection = ({ data: render }) => {
  const navigate = useNavigate();
  const { theme, url } = useOutletContext();

  const moveToPage = (item) => {
    navigate(`/shop/${url}/shoppingNoticeView/${item.noticeNo}`);
  };

  return (
    <div className={`section ${render.type}`}>
      <div className="title">
        <span>{render.name} </span> <strong>{render.data.length}</strong>
      </div>
      {render.type === "notice" ? (
        <NoticeListContainer className={`theme-${theme}`}>
          {render.data.map((item, index) => (
            <li key={index} onClick={() => moveToPage(item)}>
              <span className="noticeNo">{item.noticeNo}</span>
              <span className="noticeCl">{item.noticeCl}</span>
              <span className="noticeSj">{item.noticeSj}</span>
              <span className="createMberId">{item.createMberId}</span>
              <span className="createDt">
                {moment(item.updateDt || item.createDt).format("YYYY-MM-DD HH:mm")}
              </span>
            </li>
          ))}
        </NoticeListContainer>
      ) : (
        <ListContainer className={`theme-${theme}`}>
          {render.data.map((item) =>
            render.type === "product" ? (
              <Product item={item} url={url} />
            ) : (
              <Portfolio item={item} url={url} />
            ),
          )}
        </ListContainer>
      )}
    </div>
  );
};

export default SearchSection;
